// extracted by mini-css-extract-plugin
export default {"userMenu":"yo-user-menu_userMenu__HghE0","userIcon":"yo-user-menu_userIcon__r2Lyv","innerUserMenu":"yo-user-menu_innerUserMenu__9ltxz"};